// Newest openings / freshly-added venues, highlighted site-wide with a
// "Trending this month" badge to give fresh spots a visibility boost.
export const TRENDING_IDS = new Set([
  'next-of-kin', 'nero-yeg', 'mssm', 'north-53', 'little-wolf', 'vaticano-cucina',
  'proof-yyc', 'betty-lous-library', 'coco-cabana', 'milk-tiger', 'two-penny',
  'rundle-bar-banff', 'blanco-cantina-lethbridge',
  'wild-life-distillery', 'bridgette-bar-canmore', 'the-wood-canmore', 'buffalo-roam-saloon',
  '92-beverage-co', 'the-mill-gp',
]);

export const TRENDING_LABEL = 'Trending this month';

export const isTrending = (id) => TRENDING_IDS.has(id);

// The very freshest openings — a tighter list than TRENDING, shown with a
// distinct "NEW" ribbon so the newest 3–4 spots stand out even more.
export const NEW_IDS = new Set([
  'next-of-kin', 'nero-yeg', 'mssm', 'two-penny',
]);

export const isNew = (id) => NEW_IDS.has(id);
